module.exports = __webpack_public_path__ + "img/header.2d62bdd8.svg";